import { URLParser } from '../utils/URLParser';

export const pathnameIncludesKey = (pathParam) => {
  return (traffic) => {
    const urlObject = new URLParser(traffic.url);
    const pathParts = urlObject.pathname.split('/');
    return pathParts.includes(pathParam);
  };
};
